import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';
import Appearance from './Appearance';

export default function Appearances({ appearances, biData }) {
    if (!appearances.length) { return null; }

    const seller_card_about_me_apperance_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_apperance_impression',
        data: appearances
    });

    return (
        <WithImpressions value={seller_card_about_me_apperance_impression} className="list">
            <h3><I18n k="user_page_perseus.seller_profile.appearances"/></h3>
            <ul>
                {appearances.map((appearance, idx) =>
                    <Appearance appearance={appearance} key={idx}/>)}
            </ul>
        </WithImpressions>
    );
}

Appearances.propTypes = {
    appearances: PropTypes.array,
    biData: PropTypes.object
};

Appearances.defaultProps = {
    appearances: [],
    biData: {}
};
